[
  {
    "id": "MET-B6-L101-001",
    "module": "Metriek",
    "difficulty": 101,
    "question": "Hoeveel centimeter is 1 meter?",
    "options": ["100 cm", "10 cm", "1.000 cm", "50 cm"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte",
    "familyId": "MET-M-CM",
    "explanation": "1 meter is 100 centimeter. Denk aan een meetlat van 1 meter.",
    "distractorExplanations": {
      "1": "Dat is 1 decimeter.",
      "2": "Dat is 10 meter.",
      "3": "Dat is een halve meter."
    }
  },
  {
    "id": "MET-B6-L101-002",
    "module": "Metriek",
    "difficulty": 101,
    "question": "Hoeveel gram is 1 kilogram?",
    "options": ["1.000 gram", "100 gram", "10 gram", "500 gram"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-KG-G",
    "explanation": "Kilo betekent duizend. Dus 1 kilogram is 1.000 gram.",
    "distractorExplanations": {
      "1": "Dat is een ons.",
      "2": "Dat is heel weinig.",
      "3": "Dat is een pond."
    }
  },
  {
    "id": "MET-B6-L101-003",
    "module": "Metriek",
    "difficulty": 101,
    "question": "Wat is groter: 50 cm of 1 meter?",
    "options": ["1 meter", "50 cm", "Even groot", "Niet te zeggen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "vergelijken",
    "subSkill": "vergelijken",
    "familyId": "MET-VGL-CM-M",
    "explanation": "1 meter is 100 cm. 100 cm is meer dan 50 cm.",
    "distractorExplanations": {
      "1": "50 cm is maar een halve meter.",
      "2": "1 meter is twee keer zo groot.",
      "3": "Je kunt het wel zeggen als je omrekent."
    }
  },
  {
    "id": "MET-B6-L101-004",
    "module": "Metriek",
    "difficulty": 101,
    "question": "Hoeveel meter is 3 km?",
    "options": ["3.000 m", "300 m", "30 m", "30.000 m"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte_km",
    "familyId": "MET-KM-M",
    "explanation": "1 km is 1.000 meter. 3 km is dus 3.000 meter.",
    "distractorExplanations": {
      "1": "Je bent een nul vergeten.",
      "2": "Je bent twee nullen vergeten.",
      "3": "Dat is 30 km."
    }
  },
  {
    "id": "MET-B6-L101-005",
    "module": "Metriek",
    "difficulty": 101,
    "question": "Hoeveel liter gaat er in een emmer?",
    "options": ["10 liter", "100 liter", "1 liter", "1.000 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud_schatten",
    "familyId": "MET-SCHAT-EMMER",
    "explanation": "In een normale emmer gaat ongeveer 10 liter water.",
    "distractorExplanations": {
      "1": "Dat is een regenton.",
      "2": "Dat is een pak melk.",
      "3": "Dat is een kuub (grote bak)."
    }
  },
  {
    "id": "MET-B6-L101-006",
    "module": "Metriek",
    "difficulty": 101,
    "question": "Hoeveel centimeter is 2 meter?",
    "options": ["200 cm", "20 cm", "2.000 cm", "120 cm"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte",
    "familyId": "MET-2M-CM",
    "explanation": "1 meter is 100 cm. 2 meter is dus 2 × 100 = 200 cm.",
    "distractorExplanations": {
      "1": "Dat is 2 decimeter.",
      "2": "Dat is 20 meter.",
      "3": "Je telde er maar 20 bij op."
    }
  },
  {
    "id": "MET-B6-L101-007",
    "module": "Metriek",
    "difficulty": 101,
    "question": "Hoeveel milliliter zit er in 1 liter?",
    "options": ["1.000 ml", "100 ml", "10 ml", "500 ml"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud",
    "familyId": "MET-L-ML",
    "explanation": "Milli betekent duizendste. Er zitten 1.000 milliliter in 1 liter.",
    "distractorExplanations": {
      "1": "Dat is 1 deciliter.",
      "2": "Dat is 1 centiliter.",
      "3": "Dat is een halve liter."
    }
  },
  {
    "id": "MET-B6-L101-008",
    "module": "Metriek",
    "difficulty": 101,
    "question": "Wat is zwaarder: 2 kg of 1.500 gram?",
    "options": ["2 kg", "1.500 gram", "Even zwaar", "Niet te zeggen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "vergelijken",
    "subSkill": "vergelijken",
    "familyId": "MET-VGL-KG-G",
    "explanation": "2 kg is 2.000 gram. 2.000 gram is meer dan 1.500 gram.",
    "distractorExplanations": {
      "1": "1.500 gram is 1,5 kg. Dat is minder dan 2 kg.",
      "2": "Ze zijn niet even zwaar.",
      "3": "Je kunt het wel zeggen als je omrekent."
    }
  },
  {
    "id": "MET-B6-L101-009",
    "module": "Metriek",
    "difficulty": 101,
    "question": "Hoeveel meter is 1 km?",
    "options": ["1.000 m", "100 m", "10.000 m", "500 m"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte_km",
    "familyId": "MET-1KM-M",
    "explanation": "Kilo betekent duizend. 1 kilometer is dus 1.000 meter.",
    "distractorExplanations": {
      "1": "Dat is 1 hectometer.",
      "2": "Dat is 10 kilometer.",
      "3": "Dat is een halve kilometer."
    }
  },
  {
    "id": "MET-B6-L101-010",
    "module": "Metriek",
    "difficulty": 101,
    "question": "Wat is langer: 150 cm of 1 meter?",
    "options": ["150 cm", "1 meter", "Even lang", "Niet te zeggen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "vergelijken",
    "subSkill": "vergelijken",
    "familyId": "MET-VGL-150CM-1M",
    "explanation": "1 meter is 100 cm. 150 cm is meer dan 100 cm, dus 150 cm is langer.",
    "distractorExplanations": {
      "1": "1 meter is maar 100 cm.",
      "2": "150 cm is anderhalf keer zo lang als 1 meter.",
      "3": "Je kunt het vergelijken door om te rekenen."
    }
  },
  {
    "id": "MET-B6-L101-011",
    "module": "Metriek",
    "difficulty": 101,
    "question": "Hoeveel gram is 2 kilogram?",
    "options": ["2.000 gram", "200 gram", "20 gram", "20.000 gram"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-2KG-G",
    "explanation": "1 kg = 1.000 gram. 2 kg = 2 × 1.000 = 2.000 gram.",
    "distractorExplanations": {
      "1": "Je bent een nul vergeten.",
      "2": "Je bent twee nullen vergeten.",
      "3": "Dat is 20 kg."
    }
  },
  {
    "id": "MET-B6-L101-012",
    "module": "Metriek",
    "difficulty": 101,
    "question": "Hoeveel past er in een pak melk?",
    "options": ["1 liter", "10 liter", "100 ml", "5 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "inhoud",
    "subSkill": "inhoud_schatten",
    "familyId": "MET-SCHAT-MELK",
    "explanation": "In een gewoon pak melk zit 1 liter.",
    "distractorExplanations": {
      "1": "Dat is een emmer.",
      "2": "Dat is een klein bekertje.",
      "3": "Dat is een grote jerrycan."
    }
  },
  {
    "id": "MET-B6-L101-013",
    "module": "Metriek",
    "difficulty": 101,
    "question": "Hoeveel centimeter is een halve meter?",
    "options": ["50 cm", "25 cm", "100 cm", "500 cm"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "lengte",
    "subSkill": "lengte",
    "familyId": "MET-HALVE-M",
    "explanation": "Een halve meter is de helft van 100 cm. 100 : 2 = 50 cm.",
    "distractorExplanations": {
      "1": "Dat is een kwart meter.",
      "2": "Dat is een hele meter.",
      "3": "Dat is 5 meter."
    }
  },
  {
    "id": "MET-B6-L101-014",
    "module": "Metriek",
    "difficulty": 101,
    "question": "Wat weegt ongeveer 1 kilogram?",
    "options": ["Een pak suiker", "Een auto", "Een postzegel", "Een fiets"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "gewicht",
    "subSkill": "gewicht",
    "familyId": "MET-SCHAT-1KG",
    "explanation": "Een pak suiker weegt precies 1 kilogram.",
    "distractorExplanations": {
      "1": "Een auto weegt meer dan 1.000 kg.",
      "2": "Een postzegel weegt maar een paar gram.",
      "3": "Een fiets weegt zo'n 15 kg."
    }
  },
  {
    "id": "MET-B6-L101-015",
    "module": "Metriek",
    "difficulty": 101,
    "question": "Wat is meer: 2 liter of 1.500 ml?",
    "options": ["2 liter", "1.500 ml", "Even veel", "Niet te zeggen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "vergelijken",
    "subSkill": "vergelijken",
    "familyId": "MET-VGL-L-ML",
    "explanation": "2 liter is 2.000 ml. 2.000 ml is meer dan 1.500 ml.",
    "distractorExplanations": {
      "1": "1.500 ml is 1,5 liter. Dat is minder dan 2 liter.",
      "2": "Ze zijn niet even veel.",
      "3": "Je kunt het vergelijken door om te rekenen."
    }
  }
]